import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en';

const DEFAULT_LNG = ['en'];

const ns = [...Object.getOwnPropertyNames(en)];

export const resources = {
  en,
} as const;

i18next.use(initReactI18next).init({
  fallbackLng: DEFAULT_LNG,
  ns,
  resources,
  interpolation: {
    escapeValue: false,
  },
});

export default i18next;
